import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogoComponent } from './landing/layouts/landing/components/logo/logo.component';
import { JabilComponent } from './unauthenticated/okta/jabil/jabil.component';

const routes: Routes = [
/*   {
    path: '',
    loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule)
  }, */
  {
    path: '',
    component: JabilComponent
  },
  {
    path: 'logout',
    component: LogoComponent
  },
  {
    path: 'account',
    loadChildren: () => import('./unauthenticated/unauthenticated.module').then(m => m.UnauthenticatedModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./authenticated/authenticated.module').then(m => m.AuthenticatedModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
